import React from 'react';
import PropTypes from 'prop-types';
import { useSize } from 'ahooks';
import Title from './Title';
import './Poster.scss';

const Poster = ({ item, renderLabel, handleClick }) => {
  const dom = document.querySelector('body');
  const size = useSize(dom);

  return (
    <div
      id={item.id}
      className="poster__container"
      onClick={handleClick}
      aria-hidden="true"
    >
      {renderLabel(item)}
      <img
        src={(size.width > 650 && item.image_small) || item.image_medium}
        alt={item.title}
      />
      <div className="poster__container__info">
        <Title size={size} item={item} />
      </div>
    </div>
  );
};

Poster.propTypes = {
  item: PropTypes.object.isRequired,
  renderLabel: PropTypes.func,
  handleClick: PropTypes.func,
};

export default Poster;
